import { CheckMark } from '@lyearn/icons';
import { QuizViewField } from '@/modules/corporate/modules/questions/fields/types';
import { QuestionSubTypeEnum, QuestionTypeEnum } from '@/types/schema';

import Player from '../../../components/Player';
import QuestionReview from '../../../components/QuestionReview';
import { getQuestionEvaluation } from '../../../utils';
import { isValidSubmission } from './../../utils';

const SelectViewField: QuizViewField = {
  getQuestionEvaluation,
  isValidSubmission,
  Player,
  type: QuestionTypeEnum.SingleSelect,
  getQuestionLabel: ({ questionSubType }) =>
    questionSubType === QuestionSubTypeEnum.WeightedOption
      ? 'QuizPlayer:WeightedOption'
      : 'QuizPlayer:SingleSelect',
  labelKey: 'QuizPlayer:QuestionType.SingleSelect',
  Icon: CheckMark,
  Review: QuestionReview,
  getShouldAutoAdvance: () => true,
};

export default SelectViewField;
